<template>
  <div :style="styles.base">
    <form
      :style="styles.form"
      @submit.prevent="handleFormSubmit"
    >
      <div :style="styles.formHeader">
        <img
          :style="styles.icon"
          :src="getIcon"
        />
        <h2 :style="styles.formHeaderTitle">Sign into<br /><strong>{{getTenantName}}</strong></h2>
      </div>
      <div
        :style="styles.inputContainer"
      >
        <span :style="styles.inputContainerLabel">Email Address</span>
        <input
          class="input__text"
          ref="emailInput"
          placeholder="you@somewhere.com"
          type="email"
          v-model="email"
        />
      </div>
      <div :style="styles.inputContainer">
        <span :style="styles.inputContainerLabel">Password</span>
        <input
        class="input__text"
          placeholder="your password"
          type="password"
          v-model="password"
        >
      </div>
      <button
        class="button__submit"
        type="submit"
      >
        Login &rarr;
      </button>
    </form>
    <p>
        <router-link to="reset" class="password-link">Forgot Password?</router-link>
    </p>
  </div>
</template>

<script>
import store from '../../store';
import ls from 'local-storage';
import router from '../../router';
import { getResource, postResource } from '../../services/Utils';
export default {
  name: 'login',
  methods: {
    handleFormSubmit() {
      const domain = store.getters.getDomain;
      if (!domain) return console.error('No tenant domain found');

      const email = this.email;
      const pswd = this.password;

      this.validateLogin(domain, email, pswd)
        .then(res => {
          console.log('validated');
          ls.set('GEG__KEY', res.token);
          store.commit('setUser', res.user);
          return router.push({ name: 'dashboard' });
        })
        .catch(error => {
          ls.set('GEG__KEY', '');
          return alert(error.error ? error.error :
            'Authentication unsuccessful. Please check your credentials and try again.'
          );
        });
    },
    validateLogin(domain, email, pswd) {
      return new Promise((resolve, reject) => {
        // check tenant, email
        // get back new token
        // submit validation with token, password
        // on response, set token and redirect

        postResource('/v1/auth/login', false, { domain, email })
          .then(loginRes => {
            const token = loginRes.token;

            postResource('/v1/auth/validate', false, { token, value: pswd })
              .then(valRes => {
                return resolve(valRes);
              })
              .catch(err => reject(err));
          })
          .catch(err => reject(err));
      });
    }
  },
  computed: {
    getIcon() {
      return store.getters.getTenant.icon;
    },
    getTenantName() {
      return store.getters.getTenant.name;
    }
  },
  data() {
    return {
      email: '',
      password: '',
      styles: {
        base: {
          background: '#f5f5f5',
          boxShadow: '0 0 40px 10px rgba(0,0,0,0.2)',
          width: '60vw',
          height: '100vh',
          display: 'flex',
          flexFlow: 'column nowrap',
          alignItems: 'center',
          justifyContent: 'center'
        },
        form: {
          display: 'flex',
          flexFlow: 'column nowrap'
        },
        formHeader: {
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 40px 0'
        },
        formHeaderTitle: {
          padding: '0 20px',
          fontSize: '1.25em',
          lineHeight: '1.5',
          fontWeight: 400,
          margin: 'auto 0'
        },
        icon: {
          background: '#fff',
          padding: '15px',
          border: '1px solid #aaa',
          borderRadius: '8px',
          height: '90px',
          width: '90px',
          margin: '0px'
        },
        inputContainer: {
          marginBottom: '20px',
          display: 'flex',
          flexFlow: 'column nowrap'
        },
        inputContainerLabel: {
          color: '#888',
          fontSize: '0.8em',
          fontWeight: 700,
          textTransform: 'uppercase',
          margin: '10px 0 10px'
        }
      }
    };
  },
  mounted() {
    this.$refs.emailInput.focus();
  }
};
</script>
<style lang="scss" scoped>
button {
  margin: 40px auto 20px;
}
.password-link {
  color: #aaa;
  font-size: 1em;
  text-align: center;
  margin: 0 auto 0;
  &:hover {
    color: #09a3ed;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/Login.vue